import { useEffect } from 'react';
export const useCategoryList = props => { 
    const {fetchCategories,categories} =props
    useEffect(()=>{
        if(categories.length===0)
        fetchCategories()
    },[fetchCategories,categories])
}